import { type ComponentPropsWithoutRef, useContext } from 'react';
import { Divider, Link } from '@shc/ui';
import { formatDate } from '@lib/constants';
import useAnalytics from '@hooks/use-analytics';
import { UserContext } from '@lib/analytics';
import type { SPEvent, SPContext } from '@hooks/use-analytics'

interface SearchResultItemProps extends ComponentPropsWithoutRef<'div'> {
  title?: string;
  item: {
    slug?: string;
    publishedDate: string;
    internalName?: string;
    summary?: string;
  };
  component_text: string,
  component_url: string,
  page_type?: string;
  pathname?: string;
}

const SearchResultItem = ({
  item,
  title,
  component_text,
  component_url,
}: SearchResultItemProps) => {
  const { track } = useAnalytics();
  const user = useContext(UserContext);

  return (
    <>
      <div className={'flex flex-col pt-8'}>
        <p className={'font-semibold flex pb-5'}>{title}</p>
        <p className="flex">{item.contentType === 'news2knowArticle' && formatDate(item.publishedDate)}</p>
        <p className="flex text-[20px]">
          <Link
            className="text-tertiary hover:text-linkhover flex pt-3 pb-3 font-sans font-bold transition-colors cursor-pointer outline-offset-1 outline-2 outline-tertiary no-underline hover:underline"
            href={component_url}
            onClick={(e: React.MouseEvent<any>) => {
              e.preventDefault();
              track({
                event: {
                  name: "component_click",
                  data: {},
                } as SPEvent,
                contexts: [
                  {
                    name: "component",
                    data: {
                      component_text,
                      component_url,
                    },
                  },
                  { 
                    name: "scmg_user",
                    data: user?.data,
                  },
                ] as SPContext[],
              });
              window.location.href = component_url;
            }}
          >
            {component_text}
          </Link>
        </p>
        <p className="flex">{item.summary}</p>
      </div>
      <Divider className="pt-8" />
    </>
  );
};

export default SearchResultItem;